(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-softness"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    document.querySelectorAll('.mattress-softness__help[open]').forEach((tooltip) => {
      if (!tooltip.contains(event.target)) tooltip.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mattress-softness__help[open]').forEach((tooltip) => {
      tooltip.removeAttribute('open');
      if (tooltip.contains(document.activeElement)) tooltip.querySelector('summary').focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
